import React from "react";
import { StyledLabel } from "./style";

export const Label = StyledLabel;
